<template>
  <div class="main-container">
    <bsp-tabs :tabList="tabList" :tabIndex="tabIndex" @changeTab="changeTab">
      <div class="table-operations" slot="ope">
        <!--<el-button type="primary" @click="createCost">填写付款单</el-button>-->
      </div>
      <bsp-grid
        class="bsp-grid"
        ref="itemListTable"
        :demoLoading.sync="demoLoading"
        :tableColumns.sync="tableColumns"
        :tableDatas.sync="tableDatas"
        @tableRefresh="tableRefresh"
        @updateColumn="updateColumn"
        @checkbox-all="selectAllEvent"
        @checkbox-change="selectChangeEvent"
        :pagerConfig="pagerConfig"
        :checkbox-config="{ checkMethod: checkboxMethod, highlight: true, range: true}"
      >
        <template v-slot:discernCusIdText="{row}">
          <el-link type="primary" @click="toEditPage(row, 'view')" style = "text-overflow: ellipsis;white-space: nowrap;display:block;overflow: hidden;" >{{ row.cusName }}</el-link>
          <!--        <span>{{ discernCusMap[row.cusId]}}</span>-->
        </template>
        <template v-slot:discernStatusText="{row}">
          <span>{{ dicts.codeMap[row.status]}}</span>
        </template>
        <template v-slot:discernTdStatusText="{row}">
          <span>{{ row.isPause == "00901" ? "挂起" : dicts.codeMap[row.tdStatus]}}{{ (row.tdStatus == '80440003' || row.tdStatus == '80440007') ? '(' + row.tdRn + ')' : '' }}</span>
        </template>

        <template v-slot:operation="{row}">

          <el-image class="gridOptIcon" :src="viewIconUrl" title="查看报销明细" @click="viewCost(row.id, row)" ></el-image>
          <el-image class="gridOptIcon" :src="recheckIconUrl" title="通过" @click="approveAgreeCost(row.id, row)" ></el-image>
          <el-image class="gridOptIcon" :src="deleteIconUrl" title="驳回" @click="approveBackCost(row.id, row)" ></el-image>


        </template>
      </bsp-grid>
    </bsp-tabs>
    <opt-cost ref="optCost" @reload="doOptCostSubmit"></opt-cost>
  </div>
</template>

<script>
  import bspTabs from "@/components/bsp/bsp-tabs/bsp-tabs-v2"
  import { manageApproveCloud, manageCloudApproveCostList } from "@/api/cost/cost";
  import bspGrid from "@/components/bsp/bsp-grid/grid";
  import OptCost from "@/views/cost/components/OptCost"
  import { downloadFile } from '@/util/util'
  import {mapGetters} from 'vuex';
  import {formatDateSubstr10, formatDateSimple} from "@/util/date_format.js"

  import viewIcon from '@/assets/img/miniuiIcon/search_2.gif'
  import eidtIcon from '@/assets/img/miniuiIcon/edit_on.gif'
  import deleteIcon from '@/assets/img/miniuiIcon/delete_on.gif'
  import showIcon from '@/assets/img/miniuiIcon/view_bill.gif'
  import withdrawIcon from '@/assets/img/miniuiIcon/withdraw.png'
  import recheckIcon from '@/assets/img/miniuiIcon/recheck_on.gif'

export default {
  name: "costList",
  components: { bspTabs, bspGrid , OptCost},
  data() {
    return {
      tabList: [
        { title: '日常报销', name: 'T30030002' },
        { title: '差旅报销', name: 'T30030001' },
        { title: '供应商支付', name: 'T30030003' }
      ],
      tabIndex: 'T30030002',
      currentTab: 'T30030002',
      searchForm:{},
      searchParams: {
        startDate : "",
        endDate : ""
      },
      tableDatas: [],
      tableColumns: [],
      filtersData: { page: 1, limit: 20 },
      pagerConfig: {
        total: 0,
        page: 1,
        limit: 20
      },
      demoLoading: true,
      loadingImport: false,
      loadingBtn: false,
      multipleSelection: [],
      costType: "30030002",
      viewIconUrl : viewIcon,
      eidtIconUrl : eidtIcon,
      deleteIconUrl : deleteIcon,
      showIconUrl : showIcon,
      withdrawIconUrl : withdrawIcon,
      recheckIconUrl : recheckIcon,
    };
  },
  created() {
    if(this.$route.query.currentTab){
      this.tabIndex = this.$route.query.currentTab;
      this.currentTab = this.$route.query.currentTab;
    }
    this.costType = this.currentTab.replace("T", "");
    this.getColumn();
    this.init();
  },
  methods: {
    changeTab(tab, event) {
      this.currentTab = tab.name;
      this.costType = this.currentTab.replace("T", "");
      this.getColumn();
      this.init();
    },
    // 导出
    exportExcel() {

      this.demoLoading = true;

      var tdStatusArr = this.searchForm.tdStatusArr;
      var tdStatus = "";
      if(tdStatusArr != null && tdStatusArr.length > 0){
        for(var i = 0; i < tdStatusArr.length; i++){
          tdStatus += tdStatusArr[i] + ",";
        }
      }
      let params = {
        ...this.filtersData,
        searchParams : {
          tdStatus : tdStatus,
          cusId : this.searchForm.cusId,
          appliId : this.searchForm.appliId,
          handlerId : this.searchForm.handlerId,
          startEndDate : this.searchForm.startDate,
          endEndDate : this.searchForm.endDate,
          userTdRole : this.userTdRole,
          startCompleteDate: this.searchForm.startCompleteDate,
          endCompleteDate: this.searchForm.endCompleteDate,
          felId : this.searchForm.felId,
          tdType: this.searchForm.tdType,
          accountMonth: this.searchForm.accountMonth
        }
      }
      // exportTaskList(params)
      //   .then((res) => {
      //     if (res.headers['content-disposition'] === undefined) {
      //       this.demoLoading = false
      //       this.$message.error('账单下载失败,请联系运维人员！')
      //     } else {
      //       downloadFile(res)
      //       this.demoLoading = false
      //       this.$message.success("下载成功！");
      //     }
      //   })
    },
    // 查询
    handleSearch() {
      this.pagerConfig.page = 1;
      this.filtersData.page = 1;
      this.searchParams = this.searchForm;
      this.getData();
    },
    handleReset() {
      this.searchForm = {};
      this.initSelectForm();
      this.pagerConfig.page = 1;
      this.filtersData.page = 1;
      this.searchParams = this.searchForm;
      this.getData();
    },
    // 获取表头
    getColumn() {
      let column = [
        {
          type: "checkbox",
          setId: "",
          width: 50,
        },{
          type: "",
          field: "applierDate",
          title: "申请日期",
          //visible: false
        },{
          type: "",
          field: "createPerName",
          title: "录入人",
        },{
          type: "",
          field: "applierName",
          title: "录入人",
        },{
          type: "",
          field: "payMoney",
          title: "付款金额",
        },{
          type: "",
          field: "totalMoney",
          title: "总金额",
        },{
          type: "",
          field: "remark",
          title: "报销原因",
        },{
          type: "",
          field: "",
          title: "操作",
          minWidth : '60px',
          params:{slot:'operation'}
          //params:{slot:'discernShelvedFlagText'}
        }
      ];
      this.$set(this,"tableColumns",column);
    },
    init() {
      // if(this.$route.query.from){
      //   alert(this.$route.query.tdStatus);
      // }
      // var user = this.$store.state.user.userInfo;
      // this.userId = user.userId;
      this.getData();
    },
    viewCost(id, costBO){
      var optParam = {
        costId : costBO.id,
        editFlag : 'view',
        costStatus : costBO.costStatus,
      };
      //console.log("toEditpage");
      //console.log(this.optParam);
      this.$router.push({path:'/costApplication/costEdit',query: optParam});
    },
    doOptCostSubmit(){
      this.getData();
    },
    approveAgreeCost(id, costBO){
      var that = this;
      this.$confirm('是否审批通过？审批意见默认为同意', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.manageApproveCloud(id);
      }).catch(() => {
      });
    },
    approveBackCost(id, costBO){
      let params = {
        costId : id,
        flag : "BXDBH",
      }
      this.$refs.optCost.visible = true;
      this.$refs.optCost.optParams = params;
      this.$refs.optCost.init();
    },
    manageApproveCloud(id){
      let params = {
        costId: id,
        option: "同意",
        flag: "ok"
      }

      manageApproveCloud({mainForm : params})
        .then(res => {
          this.demoLoading = false;
          let result = res.data;
          if (result.code == 0) {
            this.$message.success('操作成功');
            this.getData();
          } else {
            this.$message.error(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          if(error.data.msg){
            this.$message.error(error.data.msg);
          }else{
            this.$message.error(error);
          }
        })
    },
    //============================================================
    // 获取数据
    getData() {
      this.demoLoading = true;
      this.$set(this.searchParams, "costType", this.costType);
      let params = {
        ...this.filtersData,
        searchParams : {
          ...this.searchParams
        }
      }
      console.log("params", params)
      manageCloudApproveCostList(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.tableDatas = result.data.data;
            this.pagerConfig.total = result.data.total;
          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error("请求异常！");
        });
    },
    //获取请求筛选数据/分页
    tableRefresh(filter, cal) {
      this.filtersData = filter;
      this.pagerConfig.page = filter.page;
      this.pagerConfig.limit = filter.limit;
      this.getData(cal);
    },
    updateColumn(columns) {
      //console.log(columns);
    },
    selectAllEvent({ checked, records, selection }) {
      this.multipleSelection = records;
    },
    selectChangeEvent({ checked, records }) {
      this.multipleSelection = records;
    },
    // 禁用表格复选框
    checkboxMethod({row}) {
      return true;
      //return row.discernStatus == '80130003';
    },
    isNotBlank(str){
      if(str == null || str ==undefined || str == ''){
        return false;
      }else{
        return true;
      }
    }
  },
  computed: {
    ...mapGetters(['billBatch','userInfo','dicts'])
  }
};
</script>

<style lang="scss" scoped>
</style>
